var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5035_34322)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0942383,
    y: 0.0117188,
    width: 62,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_5035_34322)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.594238,
    y: 0.511719,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M39.3845 23.9836L44.0907 29.8541C44.6159 30.5092 44.6159 31.568 44.0907 32.2232L39.3845 38.0937C38.8592 38.7489 38.0104 38.7489 37.4852 38.0937C36.9599 37.4385 36.9599 36.3797 37.4852 35.7245L41.2376 31.0386L37.4852 26.3527C36.9599 25.6975 36.9599 24.6388 37.4852 23.9836C38.0104 23.3284 38.8592 23.3284 39.3845 23.9836ZM24.5936 26.3527L20.8391 31.0386L24.5936 35.7245C25.1188 36.3797 25.1188 37.4385 24.5936 38.0937C24.0683 38.7489 23.2195 38.7489 22.6943 38.0937L17.9869 32.2232C17.4618 31.568 17.4618 30.5092 17.9869 29.8541L22.6943 23.9836C23.2195 23.3284 24.0683 23.3284 24.5936 23.9836C25.1188 24.6388 25.1188 25.6975 24.5936 26.3527Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5035_34322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0225 19.7517L29.644 43.2341C29.4381 44.1252 28.6944 44.6389 27.98 44.3873C27.2657 44.1304 26.8539 43.2027 27.0556 42.3116L32.4341 18.8302C32.64 17.9395 33.3838 17.4237 34.0981 17.6783C34.8124 17.9327 35.2242 18.8612 35.0225 19.7517Z",
    fill: "url(#paint1_linear_5035_34322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9303 18.1493L33.9303 18.1493C34.3389 18.2948 34.6978 18.9208 34.535 19.6407C34.535 19.6409 34.5349 19.6411 34.5349 19.6413L29.1569 43.1216C29.1568 43.1217 29.1568 43.1218 29.1568 43.1219C28.994 43.8258 28.4883 44.035 28.1477 43.9162C27.7378 43.7677 27.3807 43.1415 27.5431 42.4226C27.5432 42.4224 27.5432 42.4222 27.5433 42.422L32.9213 18.9428C32.9213 18.9427 32.9214 18.9425 32.9214 18.9423C33.0849 18.236 33.592 18.0287 33.9303 18.1493Z",
    stroke: "white",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5035_34322",
    x: -4.90576,
    y: -4.98828,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34322"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34322",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5035_34322",
    x: 5.00439,
    y: -4.38672,
    width: 52.0693,
    height: 70.8359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34322"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34322",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5035_34322",
    x1: -2.4891,
    y1: 64.0784,
    x2: 33.8751,
    y2: -4.06144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131727,
    stopColor: "#26994E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839719,
    stopColor: "#8EDF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5035_34322",
    x1: 27.5845,
    y1: 19.9257,
    x2: 38.0854,
    y2: 21.1808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopers);
export default __webpack_public_path__ + "static/media/developers.30b153c0b8931281f71eef641f375568.svg";
export { ForwardRef as ReactComponent };